var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.config.previewSrc && (!_vm.config.ext || !_vm.typeMap[_vm.config.ext.toLowerCase()] || !_vm.config.src))?[_vm._v(_vm._s(_vm.config.noDisplayText || ""))]:(_vm.config.previewSrc || _vm.typeMap[_vm.config.ext.toLowerCase()] === 'web')?[_c('iframe',{staticClass:"e-document-view-iframe",attrs:{"src":_vm.config.src}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }